const unknownItemOptionSetData = JSON.parse(sessionStorage.getItem('unknownItemOptionSetData'));
const optionSet = unknownItemOptionSetData?.activeTradeinUnknownOptionSet;
if (!optionSet || !optionSet.rootEntries || optionSet.rootEntries.length === 0) {
  window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-search-2`);
}

const departmentSelect = document.getElementById('department-select');
const categorySelect = document.getElementById('category-select');
const subcategorySelect = document.getElementById('subcategory-select');
const subcategoryLabel = document.querySelector('.item-subcategory-label');
const subcategorySelectWrapper = document.querySelector('.item-subcategory-label + .select');
const lookupButton = document.getElementById('trade-in-alternative-lookup-button');
let currentlySelectedDepartment = null;
let currentlySelectedCategory = null;
let currentlySelectedSubcategory = null;

function enableLookupButton(event) {
  return lookupButton.disabled = !event.target.value;
}

function resetSelectElement({ element, defaultText }) {
  element.disabled = true;
  element.value = '';
  element.replaceChildren();
  const defaultOption = document.createElement('option');
  defaultOption.textContent = defaultText;
  defaultOption.value = '';
  defaultOption.selected = true;
  defaultOption.disabled = true;
  element.appendChild(defaultOption);
}

function renderSelectOption({ element, value, textContent }) {
  const categoryOption = document.createElement('option');
  categoryOption.textContent = textContent;
  categoryOption.classList.add('category-option');
  categoryOption.value = value;
  element.appendChild(categoryOption);
  element.disabled = false;
}

function handleSelectDepartment(event) {
  const {
    selectCategory,
    selectSubcategory,
  } = TRADE_IN_ALTERNATIVE_LOOKUP_CONFIG;
  resetSelectElement({ element: categorySelect, defaultText: selectCategory });
  resetSelectElement({ element: subcategorySelect, defaultText: selectSubcategory });
  lookupButton.disabled = true;

  const selectedEntry = optionSet.rootEntries.find(
    entry => entry.code === event.target.value,
  );
  currentlySelectedDepartment = selectedEntry;
  currentlySelectedCategory = null;
  currentlySelectedSubcategory = null;

  if (selectedEntry.childEntries) {
    selectedEntry.childEntries.forEach((child) => {
      renderSelectOption({
        element: categorySelect,
        value: child.code,
        textContent: child.name,
      });
    });
  }
}

function handleSelectCategory(event) {
  const selectedEntry = currentlySelectedDepartment.childEntries.find(
    entry => entry.code === event.target.value,
  );
  currentlySelectedCategory = selectedEntry;
  currentlySelectedSubcategory = null;

  if (selectedEntry.childEntries) {
    setupSubcategorySelect(selectedEntry);
  } else {
    enableLookupButton(event);
  }
}

function setupSubcategorySelect(categoryEntry) {
  const {
    selectSubcategory,
  } = TRADE_IN_ALTERNATIVE_LOOKUP_CONFIG;
  resetSelectElement({ element: subcategorySelect, defaultText: selectSubcategory });
  categoryEntry.childEntries.forEach((child) => {
    renderSelectOption({
      element: subcategorySelect,
      value: child.code,
      textContent: child.name,
    });
  });
}

function handleSelectSubcategory(event) {
  currentlySelectedSubcategory = currentlySelectedCategory.childEntries.find(
    entry => entry.code === event.target.value,
  );
  enableLookupButton(event);
}

async function fetchConditionValues(entryAddress) {
  const query = `
    query tradeinUnknownConditionValuesFetch(
      $partnerUuid: String!
      $entryAddress: TradeinUnknownOptionSetEntryAddressCommerce!
    ) {
      activeTradeinUnknownOptionSet(partnerUuid: $partnerUuid) {
        childEntry(entryAddress: $entryAddress) {
          ... on TradeinUnknownOptionSetLeafEntryCommerce {
            conditionValues {
              tradeinValue
              displayTradeinValue
              condition {
                name
                displayName
                rank
              }
            }
          }
        }
      }
    }
  `;
  const param = 'query-tradeinUnknownConditionValuesFetch';
  const response = await fetchWithAppName(`${global.url}${param}`, {
    body: JSON.stringify({
      query,
      variables: {
        partnerUuid: global.partnerUuid,
        entryAddress,
      },
    }),
  });
  const jsonData = await response.json();
  return jsonData.data.activeTradeinUnknownOptionSet.childEntry.conditionValues;
}

async function submitUnknownItem() {
  lookupButton.disabled = true;

  const tagValues = [
    { tag: optionSet.rootTag, code: currentlySelectedDepartment.code },
  ];

  if (currentlySelectedCategory) {
    tagValues.push({
      tag: currentlySelectedDepartment.childTag,
      code: currentlySelectedCategory.code,
    });
  }
  if (currentlySelectedSubcategory) {
    tagValues.push({
      tag: currentlySelectedCategory.childTag,
      code: currentlySelectedSubcategory.code,
    });
  }

  const submittedUnknownItemConditions = await fetchConditionValues({ tagValues });

  const leaf = currentlySelectedSubcategory || currentlySelectedCategory;

  const currentTradeinItem = {
    department: currentlySelectedDepartment.code,
    departmentDisplay: currentlySelectedDepartment.name,
    category: (currentlySelectedCategory || currentlySelectedDepartment).code,
    categoryDisplay: (currentlySelectedCategory || currentlySelectedDepartment).name,
    subcategory: currentlySelectedSubcategory?.code,
    subcategoryDisplay: currentlySelectedSubcategory?.name,
    isUnknown: true,
    submittedUnknownItemConditions,
    initiatedTagValues: tagValues,
    rubricCode: null,
  };

  sessionStorage.setItem('currentTradeinItem', JSON.stringify(currentTradeinItem));

  window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-eligibility`);
}

document.addEventListener('DOMContentLoaded', () => {
  const {
    selectDepartment,
  } = TRADE_IN_ALTERNATIVE_LOOKUP_CONFIG;
  resetSelectElement({ element: departmentSelect, defaultText: selectDepartment });
  optionSet.rootEntries.forEach((entry) => {
    renderSelectOption({
      element: departmentSelect,
      value: entry.code,
      textContent: entry.name,
    });
  });
  if (optionSet.rootEntries.some(entry =>
    entry.childEntries?.some(child => child.childEntries)
  )) {
    subcategoryLabel.classList.remove('hidden');
    subcategorySelectWrapper.classList.remove('hidden');
  }
});

departmentSelect.addEventListener('change', handleSelectDepartment);
categorySelect.addEventListener('change', handleSelectCategory);
subcategorySelect.addEventListener('change', handleSelectSubcategory);
lookupButton.addEventListener('click', submitUnknownItem);
